import React, { useEffect, useState } from 'react';
import { useParams  } from "react-router-dom";
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import images from '../../../services/images';
import initTreeView from '../../../services/initTreeView';
import StoreInfo from '../../parts/StoreInfo';

export default function BillPrintView (){
    const { bill_id } = useParams();
    const [loading, setLoading] = useState(1);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [record_data, setRecordData] = useState(store.bill_data);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    
   
    useEffect(() => {
        initTreeView()

        if(bill_id){
            fetchData(bill_id)
        }
    }, []);

    useEffect(() => {
        displayTableItems()
    }, [record_items]);

    function fetchData(bill_id){
        if(!bill_id){
            return
        }
        const url = helpers.createUrl('V1/manage/bills/'+bill_id+'?store_id='+helpers.getStoreID())

        httpRequest(url, "GET", {}, true)
        .then((res) => {
            let items = res;
            items.bill_date = new Date(res.bill_date)
            items.due_date = new Date(res.due_date)

            setLoading(0)
            setRecordData(items)
            setRecordItems(items.items)
            setRecordLoaded(1)
            
            setTimeout(function(){
                window.print()
            }, 2000);
        })
        .catch((err) => {
            setLoading(0)
            //getEnums()

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace(`/bills/${bill_id}`);
                }
            })
        }); 

    }

    function displayTableItems(){
        let items = []
        
        if (record_items.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                return(
                <tr>
                    <td>
                        <div className='mb-0'>{data.product_name}{data.product_variant_name != 'Generic' ? ` (${data.product_variant_name})` : ''}</div>
                        <div><small>SKU: {data.product_code}</small></div>
                        {data.product_description ? <div className='mt-1'><small style={{whiteSpace: 'pre-line'}}>{data.product_description}</small></div> : ''}
                    </td>
                    {/* <td>{data.product_code}</td> */}
                    <td>{data.quantity}{data.unit_name ? ` ${data.unit_name}` : ''}</td>
                    <td>{helpers.formatCurrencyAmount(data.amount)}</td>
                    {/* <td>{data.tax_amount ? helpers.formatCurrencyAmount(data.tax_amount) : '---'}</td> */}
                    <td>{helpers.formatCurrencyAmount(data.total_amount)}</td>
                </tr>)

            })
        }

        setTableItems(<tbody>{items}</tbody>)
    }

    function computeSubTotals(){
        let items = 0;
        let total_amount = 0
        Object.entries(record_items).map(([key, data]) => {
            items = items + Number(data.quantity)
            total_amount = total_amount + parseInt(data.quantity) * parseFloat(data.amount)
        });

        return helpers.formatAmount(total_amount);
    }
    function computeSubTotals(){
        let items = 0;
        let total_amount = 0
        Object.entries(record_items).map(([key, data]) => {
            items = items + Number(data.quantity)
            total_amount = total_amount + parseInt(data.quantity) * parseFloat(data.amount)
        });

        return helpers.formatCurrencyAmount(total_amount);
    }

    function print(){
        window.print()
    }

    return (
        <div className="invoice p-4 mb-3">
            <Loader isLoading={loading}/>
            <div className="d-flex justify-content-between mb-3">
                <StoreInfo store={record_data.store_info} />

                <div className='text-right'>
                    <h2><strong>BILL</strong></h2>
                    {/* <h5>{helpers.displayBillStatusBadge(record_data.status_id, record_data.bill_status)}</h5> */}
                    <h5 className='mb-0'>{record_data.bill_no ? `${record_data.bill_no}` : '---'}</h5>
                </div>
            </div>

            <div className="row">
                <div className="col-4 mb-3">
                    <h5 className='mb-0'><b>Bill To:</b></h5>
                    <div>
                        <p className='mb-0'><b>{record_data.vendor_name}</b></p>
                        <p className='mb-0'>{record_data.billing_address}</p>
                        <p className='mb-0'>{record_data.billing_contact_number}</p>
                    </div>
                </div>
                <div className="col-4 mb-3">
                    <h5 className='mb-0'><b>Ship To:</b></h5>
                    <div>
                        <p className='mb-0'><b>{record_data.shipping_contact_name}</b></p>
                        <p className='mb-0'>{record_data.shipping_address}</p>
                        <p className='mb-0'>{record_data.shipping_phone}</p>
                    </div>
                </div>
                <div className="col-4 text-lg-right mb-2">
                    <table className='table table-borderless table-sm'>
                        <tbody>
                            {/* <tr>
                                <td className='pb-0'><b>Bill No:</b></td>
                                <td className='pb-0'>{record_data.bill_no ? record_data.bill_no : '---'}</td>
                            </tr> */}
                            <tr>
                                <td className='py-0'><b>Date:</b></td>
                                <td className='py-0'>{record_loaded ? helpers.formatDate(record_data.bill_date) : '---'}</td>
                            </tr>
                            <tr>
                                <td className='py-0'><b>PO #:</b></td>
                                <td className='py-0'>{record_data.order_no ? record_data.order_no : '---'}</td>
                            </tr>
                            <tr>
                                <td className='py-0'><b>Payment Terms:</b></td>
                                <td className='py-0'>{record_data.payment_term ? record_data.payment_term : '---'}</td>
                            </tr>
                            <tr>
                                <td className='py-0'><b>Due Date:</b></td>
                                <td className='py-0'>{record_data.due_date ? helpers.formatDate(record_data.due_date) : '---'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className='table-responsive'>
                <table className='table table-striped table-sm border-bottom'>
                    <thead>
                        <tr>
                            <th>Item & Description</th>
                            {/* <th>SKU</th> */}
                            <th>Quantity</th>
                            <th>Price</th>
                            {/* <th>Tax</th> */}
                            <th>Amount</th>
                        </tr>
                    </thead>
                    {
                        table_items
                    }
                </table>
            </div>

            <div className='row'>
                <div className="col-7 d-flex align-items-center">{record_loaded && record_data.customer_notes ? <p className='pt-1 pt-lg-4'>{record_data.customer_notes}</p>:''}</div>
                <div className="col-5 mb-2 border p-2">
                    <table className='table table-sm table-borderless mb-0'>
                        <tbody>
                            <tr>
                                <td className='border-top-0'><b>Sub Total</b></td>
                                <td className='border-top-0'>{computeSubTotals()}</td>
                            </tr>
                            <tr>
                                <td><b>Shipping Fee</b></td>
                                <td>{helpers.formatCurrencyAmount(record_data.shipping_fee)}</td>
                            </tr>
                            <tr>
                                <td><b>Tax</b></td>
                                <td>{parseFloat(record_data.total_tax) > 0 ? helpers.formatCurrencyAmount(record_data.total_tax) : '---'}</td>
                            </tr>
                            <tr>
                                <td><b>Total</b></td>
                                <td>{helpers.formatCurrencyAmount(record_data.total_amount)}</td>
                            </tr>
                            <tr>
                                <td><b>Balance Due:</b></td>
                                <td>{helpers.formatCurrencyAmount(record_data.balance_amount)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row border-top mt-5">
                <div className="col-12 text-center">
                    <small>This is a system-generated report. Powered by Topventory.</small>
                </div>
            </div>
        </div>
    )
}